import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.m.two,
    [
      face.u.two,
      face.m.two,
      face.u.two,
    ],
  ],
  name: 'Bars',
};
